import { useCircleV4 } from "@/react/hooks/useCircleV4";

// The admin dock nav ships with the Circle 4.0 UI, so it shares the member-area
// AppShell condition (the active v4 UI).
export const useIsCircleAIDockNavEnabled = () => useCircleV4().isCircleV4;
